module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Z8z3"))).then(() => module.bundle.root('jnagv'));